<script lang="ts">
    import CarruCasosExito from './oferta/CasosExitoPrime.vue';


    export default {
        components: { CarruCasosExito },
        data() {
            return {
                currentIndex: 0,
                alumnosEgresados: 0,
                animating: false,
            };
        },
        mounted() {
            this.initIntersectionObserver();
        },
        methods: {
            startAnimation() {
                if (!this.animating) {
                    this.animating = true;
                    let counter = 0;
                    const interval = setInterval(() => {
                        this.alumnosEgresados = counter;
                        counter += 111; // incremento
                        if (counter >= 100000) {
                            clearInterval(interval);
                            this.alumnosEgresados = 100000;
                        }
                    }, 2); // Velocidad
                }
            },
            initIntersectionObserver() {
                const target = document.getElementById('ventajas');
                if (target) {
                    const observer = new IntersectionObserver((entries) => {
                    if (entries[0].isIntersecting && !this.animating) {
                        setTimeout(() => {
                            this.startAnimation();
                        }, 300);
                        observer.disconnect(); // Desconectar después de cargar el script
                    }
                    });
                    observer.observe(target);
                }
            },
        }
    };
</script>


<template>
    <div class="flex flex-col justify-center w-full " >
        <section class="flex justify-center mb-8 w-full h-full min-h-[652px]" loading="lazy" style="background-image: url(/pagesImages/ventajas-BG.webp); position: relative; background-attachment: fixed; background-position: center; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
            <div class="flex flex-col w-full justify-center items-center max-w-4xl lg:max-w-[1200px]">
                <div id="ventajas" class="flex flex-col container justify-center items-center mx-auto max-w-4xl lg:max-w-6xl my-20 w-full md:w-2/3 lg:w-2/5 text-white">
                    <h1 class="sr-only">Universidad Humanitas</h1>
                    <h2 class="text-center w-full">
                        <span class="block text-3xl">Ventajas de estudiar en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-5xl text-hgold font-['Times'] tracking-widest">Humanitas</span>
                    </h2>
                    <p class=" text-center text-2xl w-full">
                        M&aacute;s de {{ alumnosEgresados.toLocaleString('es-MX') }}
                    </p>
                    <p class=" text-center text-2xl  w-full">
                        alumnos y egresados
                    </p>
                    <div class="flex flex-col justify-center items-center w-full">
                        <div class="flex justify-between items-center w-full">
                            <div class="flex flex-col justify-center items-center w-full">
                                <img  src="/pagesImages/programas.png" width="100" height="100" loading="lazy" class="w-[100px] h-[100px]" alt="Modelo educativo por especialidad">
                                <h3 class="text-xs w-full text-center">
                                    Modelo educativo <br>por especialidad
                                </h3>
                            </div>
                            <div class="flex flex-col justify-center items-center w-full">
                                <img  src="/pagesImages/excelencia.png" width="100" height="100" loading="lazy" class="w-[100px] h-[100px]" alt="Excelencia Académica">
                                <h3 class="text-xs w-full text-center">
                                    Excelencia <br>acad&eacute;mica
                                </h3>
                            </div>
                            <div class="flex flex-col justify-center items-center w-full">
                                <img  src="/pagesImages/instalaciones.png" width="100" height="100" loading="lazy" class="w-[100px] h-[100px]" alt="Instalaciones extraordinarias">
                                <h3 class="text-xs w-full text-center">
                                    Instalaciones <br>extraordinarias
                                </h3>
                            </div>
                            <div class="flex flex-col justify-center items-center w-full">
                                <img  src="/pagesImages/costos.png" width="100" height="100" loading="lazy" class="w-[100px] h-[100px]" alt="Costos accesibles">
                                <h3 class="text-xs w-full text-center">
                                    Costos <br>accesibles
                                </h3>
                            </div>
                        </div>
                        <div class="w-full h-8 border-b-2 border-white"></div>
                        <div class="w-full h-8"></div>
                        <div class="flex justify-between items-center w-full">
                            <div class="flex flex-col justify-center items-center w-full">
                                <img  src="/pagesImages/sep.png" width="100" height="100" loading="lazy" class="w-[100px] h-[100px]" alt="Reconocimiento de validez oficial (SEP)">
                                <h3 class="text-xs w-full text-center">
                                    Reconocimiento de <br>validez oficial
                                </h3>
                            </div>
                            <div class="flex flex-col justify-center items-center w-full">
                                <img  src="/pagesImages/esr.png" width="100" height="100" loading="lazy" class="w-[100px] h-[100px]" alt="Empresa Socialmente Responsable">
                                <h3 class="text-xs w-full text-center">
                                    Empresa <br>Socialmente <br>Responsable
                                </h3>
                            </div>
                            <div class="flex flex-col justify-center items-center w-full">
                                <img  src="/pagesImages/gtpw.png" width="100" height="100" loading="lazy" class="w-[100px] h-[100px]" alt="Great Place to Work">
                                <h3 class="text-xs w-full text-center">
                                    Great Place to <br> Work
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="flex w-full items-center justify-center min-h-[1642px] h-full text-gray-700">
            <div class="flex flex-col w-full max-w-[1200px] justify-center items-center">
                <!-- Licenciaturas -->
                <div class="flex flex-col md:flex-row items-center justify-center mb-10 w-full max-w-4xl lg:max-w-[1200px]">
                    <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end">
                        <img src="/pagesImages/square-lics.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora las licenciaturas">
                    </div>
                    <div class="order-1 md:order-2 flex flex-col md:pl-14 px-4 py-7 md:py-0 w-full md:w-1/2 items-center md:items-start">
                        <p class="text-center md:text-left line-height-36 text-4xl text-hgold mb-2 font-serif">Licenciaturas</p>
                        <ul class="text-left pl-6 list-disc">
                            <li><a href="https://humanitas.edu.mx/licenciatura-en-administracion">Administración</a></li>
                            <li><a href="https://humanitas.edu.mx/licenciatura-en-arquitectura">Arquitectura</a></li>
                            <li><a href="https://humanitas.edu.mx/licenciatura-en-arte-y-teatro">Arte y Teatro</a></li>
                            <li><a href="https://humanitas.edu.mx/licenciatura-en-contabilidad">Contabilidad</a></li>
                            <li><a href="https://humanitas.edu.mx/licenciatura-en-derecho">Derecho</a></li>
                            <li><a href="https://humanitas.edu.mx/licenciatura-en-diseno-grafico">Diseño Gráfico</a></li>
                            <li><a href="https://humanitas.edu.mx/licenciatura-en-psicologia">Psicología</a></li>
                        </ul>
                        <br>
                    </div>
                </div>
                <!-- Maestrías -->
                <div class="flex flex-col md:flex-row items-center justify-center my-10 w-full max-w-4xl lg:max-w-[1200px]">
                    <div class="flex flex-col md:pr-14 px-4 pb-7 md:pb-0 w-full md:w-1/2 items-center md:items-end">
                        <span class="list-none">
                            <p class="text-left line-height-36 text-4xl text-hgold mb-2 font-serif">Maestr&iacute;as</p>
                            <ul class="text-left pl-6 list-disc">
                                <li><a href="https://humanitas.edu.mx/maestria-en-alta-direccion">Alta Dirección Corporativa</a></li>
                                <li><a href="https://humanitas.edu.mx/maestria-en-contabilidad-e-impuestos">Contabilidad</a></li>
                                <li><a href="https://humanitas.edu.mx/maestria-en-derecho-corporativo">Derecho Corporativo</a></li>
                                <li><a href="https://humanitas.edu.mx/maestria-en-derecho-fiscal">Derecho Fiscal</a></li>
                                <li><a href="https://humanitas.edu.mx/maestria-en-derecho-penal">Derecho Penal</a></li>
                                <li><a href="https://humanitas.edu.mx/maestria-en-educacion">Educación</a></li>
                                <!-- <li><a href="https://humanitas.edu.mx/maestria-en-mercadotecnia-digital">Mercadotecnia Digital</a></li> -->
                                <li><a href="https://humanitas.edu.mx/maestria-en-mercadotecnia">Mercadotecnia</a></li>
                                <li><a href="https://humanitas.edu.mx/maestria-en-psicoterapia">Psicoterapia con un<br> Enfoque Psicoanalítico</a></li>
                            </ul>
                            <br>
                        </span>
                    </div>
                    <div class="flex w-full md:w-1/2 justify-center md:justify-start">
                        <img src="/pagesImages/square-maes.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Conoce las mestrías">
                    </div>
                </div>
                <!-- Doctorados -->
                <div class="flex flex-col md:flex-row items-center justify-center mt-10 w-full max-w-4xl lg:max-w-[1200px]">
                    <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end">
                        <img src="/pagesImages/square-docs.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Conoce los doctorados">
                    </div>
                    <div class="order-1 md:order-2 flex flex-col md:pl-14 px-4 pb-7 md:pb-0 w-full md:w-1/2 items-center md:items-start">
                        <p class="text-center md:text-left line-height-36 text-4xl text-hgold mb-2 font-serif">Doctorados</p>
                        <ul class="text-left pl-6 list-disc">
                            <li><a href="https://humanitas.edu.mx/doctorado-en-alta-direccion">Alta Dirección Corporativa</a></li>
                            <li><a href="https://humanitas.edu.mx/doctorado-en-derecho">Derecho</a></li>
                            <li><a href="https://humanitas.edu.mx/doctorado-en-educacion">Educación</a></li>
                        </ul>
                        <br>
                    </div>
                </div>
            </div>
        </section>

        <br>
        <br>
        <div class="h-full min-h-[320px]">
            <EgresadosHuma :types="'Nosotros'" class="mb-12 w-full"/>
        </div>
        <div class="h-full min-h-[320px]">
            <EgresadosHuma :types="'Querer'" class="mb-12 w-full"/>
        </div>
        <div class="flex items-center justify-center w-full">
            <div class="max-w-[1200px] text-center flex relative justify-center">
                <CarruCasosExito/>
            </div>
        </div>
    </div>
</template>


<style scoped>
    
</style>